import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, IconButton, Typography } from "@mui/material";
import { Modal } from "app/components/Modal";
import React, { UIEvent } from "react";

import { useAddRegistrationModal } from "../../hooks/useAddRegistrationModal";
import { RegistrationFormDropDownKey } from "../../types";
import AddRegistrationField from "./AddRegistrationField";
import { useStyles } from "./styles";

const AddRegistrationModal = () => {
  const styles = useStyles();
  const {
    t,
    open,
    form,
    saving,
    rows,
    isValid,
    addTitle,
    onClose,
    setField,
    placeholder,
    fieldLabel,
    optionLabel,
    isNumberField,
    onSubmit,
    onDropDownScroll,
    hasMoreDropDownItems,
  } = useAddRegistrationModal();

  const handleMenuScroll =
    (dropDownKey?: RegistrationFormDropDownKey) =>
    (event: UIEvent<HTMLElement>) => {
      if (!dropDownKey || !hasMoreDropDownItems(dropDownKey)) return;

      const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
      if (scrollHeight - (scrollTop + clientHeight) <= 2) {
        onDropDownScroll(dropDownKey);
      }
    };

  return (
    <Modal open={open} onClose={onClose}>
      <Box className={styles.modal}>
        <Box className={styles.header}>
          <Typography className={styles.title}>{addTitle}</Typography>
          <IconButton
            className={styles.closeButton}
            onClick={onClose}
            aria-label={t("BUTTONS.CANCEL")}
            disabled={saving}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Box className={styles.body}>
          {rows.map((row, index) => (
            <Box
              key={index}
              className={row.length === 3 ? styles.gridThree : styles.grid}
            >
              {row.map((field) => (
                <AddRegistrationField
                  key={field.key}
                  field={field}
                  value={form[field.key]}
                  disabled={saving}
                  isNumber={isNumberField(field.key)}
                  fieldLabel={fieldLabel}
                  placeholder={placeholder}
                  optionLabel={optionLabel}
                  onMenuScroll={handleMenuScroll(field.dropDownKey)}
                  onChange={(value) => setField(field.key, value)}
                />
              ))}
            </Box>
          ))}
        </Box>

        <Box className={styles.footer}>
          <Button
            className={styles.cancelButton}
            variant="outlined"
            onClick={onClose}
            disabled={saving}
          >
            {t("BUTTONS.CANCEL")}
          </Button>
          <Button
            className={styles.addButton}
            variant="contained"
            disableElevation
            disabled={!isValid || saving}
            onClick={onSubmit}
          >
            {t("BUTTONS.ADD")}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddRegistrationModal;
